var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    viewBox: "0 0 133.038 133.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1381",
    "data-name": "Group 1381",
    transform: "translate(-80.308 -709.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1380",
    "data-name": "Group 1380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1379",
    "data-name": "Group 1379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M4336.363,781.07a65.019,65.019,0,1,1-65.017-65.026A65.017,65.017,0,0,1,4336.363,781.07Z",
    transform: "translate(-4124.517 -5)",
    fill: "none",
    stroke: "#272427",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ruler",
    d: "M4239.183,831.819l92.7,0a1.215,1.215,0,0,0,1.067-1.28l-.006-29.93a1.19,1.19,0,0,0-1.064-1.276l-11.267,0-.476,0-80.947,0a.967.967,0,0,0-.75.369,1.371,1.371,0,0,0-.308.9l-.012,29.952a1.452,1.452,0,0,0,.32.885A1.008,1.008,0,0,0,4239.183,831.819Zm4.734-21.991a1.376,1.376,0,0,0,.313.9.952.952,0,0,0,.748.372,1.21,1.21,0,0,0,1.066-1.279l-.006-7.931,3.6.006v13.163a1.38,1.38,0,0,0,.313.907.941.941,0,0,0,.75.369,1.215,1.215,0,0,0,1.064-1.276l0-13.166,3.762-.008,0,7.951a1.181,1.181,0,0,0,1.064,1.276,1.225,1.225,0,0,0,1.067-1.28l0-7.944,3.588,0,0,13.174a1.185,1.185,0,0,0,1.061,1.272,1.214,1.214,0,0,0,1.067-1.28V801.888l3.76,0,0,7.944a1.193,1.193,0,0,0,1.07,1.284,1.239,1.239,0,0,0,1.064-1.276l-.009-7.959,3.593.011v13.178a1.405,1.405,0,0,0,.315.9.982.982,0,0,0,.749.38,1.224,1.224,0,0,0,1.066-1.28V801.885l3.766,0,0,7.95a1.179,1.179,0,0,0,1.065,1.276,1.222,1.222,0,0,0,1.065-1.279l-.005-7.947h3.59v13.177a1.38,1.38,0,0,0,.313.907.943.943,0,0,0,.75.369,1.217,1.217,0,0,0,1.064-1.276l0-13.174h3.756l0,7.951a1.371,1.371,0,0,0,.31.895.973.973,0,0,0,.753.381,1.224,1.224,0,0,0,1.067-1.28l0-7.95,3.592.011,0,13.166a1.182,1.182,0,0,0,1.06,1.272,1.215,1.215,0,0,0,1.066-1.28V801.888h3.75l.013,7.94a1.346,1.346,0,0,0,.307.9.963.963,0,0,0,.756.376,1.216,1.216,0,0,0,1.063-1.276l-.008-7.944,3.6,0v13.178a1.2,1.2,0,0,0,1.063,1.276,1.225,1.225,0,0,0,1.067-1.28V801.885l3.761,0,.009,7.944a1.387,1.387,0,0,0,.3.9.968.968,0,0,0,.759.372,1.209,1.209,0,0,0,1.06-1.272l0-7.947,3.6-.006v13.177a1.368,1.368,0,0,0,.313.907.946.946,0,0,0,.751.369,1.214,1.214,0,0,0,1.063-1.276l0-13.174,3.67.008,0,7.942a1.181,1.181,0,0,0,1.065,1.277,1.22,1.22,0,0,0,1.063-1.276l0-7.951h3.578l.007,27.378H4240.25l0-27.381,3.659.006Z",
    transform: "translate(-668.607 5061.598) rotate(-90)",
    fill: "#272327"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/Height.74f83ecd.svg";
export { ForwardRef as ReactComponent };